import AdvanceInitContainer from "../../../../components/formsAndTable/tables/dataTables/advanceInit";

const AdvanceInit = () => {
  return <AdvanceInitContainer />;
};

export default AdvanceInit;
